import { feedItems } from "@/mocks/gua";

export default function FeedGrid() {
  const items = feedItems.slice(1, 6);
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill" />
              </span>
              近期猛料速览
            </h3>
            <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">
              大小卡混排网格 —— 追完热榜，再来把这几条劲爆内容补齐。
            </p>
          </div>
          <a href="#" className="hidden items-center gap-1 whitespace-nowrap text-sm text-foreground-700 hover:text-primary-600 sm:inline-flex">
            查看全部 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it, idx) => {
            const isWide = idx === 0;
            return (
              <a
                key={it.id}
                href="#"
                className={
                  isWide
                    ? "group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 sm:col-span-2 lg:col-span-2"
                    : "group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
                }
              >
                <div className="flex items-center gap-2">
                  <span className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                    <i className="ri-price-tag-3-line" /> {it.tag}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line" /> {it.time}
                  </span>
                </div>
                <h4 className="mt-3 text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                  {it.title}
                </h4>
                {isWide ? (
                  <>
                    <p className="mt-2 text-sm leading-6 text-foreground-700">{it.excerpt}</p>
                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                      <span className="inline-flex items-center gap-1"><i className="ri-hashtag" />{it.meta}</span>
                      <span className="inline-flex items-center gap-1 font-medium text-foreground-800"><i className="ri-fire-line" /> {it.heat}</span>
                      <span className="inline-flex items-center gap-1 text-primary-500"><i className="ri-arrow-up-line" />{it.trend}</span>
                    </div>
                  </>
                ) : (
                  <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{it.excerpt}</p>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}